import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.API_BASE_URL}`;

class DashboardService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getMediaAndEventsDashboardStats() {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/events/statistics`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason ||
          "Media and events dashboard stats fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.message ||
          "An error occurred while getting media and events dashboard stats",
      };
    }
  }
}
const dashboardService = new DashboardService();
export default dashboardService;
